import React from 'react';
import { useSession } from '../contexts/SessionContext';
import '../styles/page-base.css';

export default function NoOrganizationNotice() {
  const { user, signOut } = useSession();

  const handleSignOut = async () => {
    await signOut();
    window.location.href = '/signin';
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="mb-6">
          <svg
            className="mx-auto h-16 w-16 text-orange-500"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
        </div>
        
        <h1 className="text-2xl font-bold text-gray-900 mb-4">
          No Organization Access
        </h1>
        
        <p className="text-gray-600 mb-6">
          Your account ({user?.email}) is not associated with any organization.
        </p>
        
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6 text-left">
          <p className="text-sm text-yellow-800 font-semibold mb-2">
            What to do:
          </p>
          <ul className="text-sm text-yellow-700 space-y-1 list-disc list-inside">
            <li>Contact your administrator to be added to an organization</li>
            <li>Or contact support</li>
          </ul>
        </div>
        
        <div className="flex flex-col gap-3">
          <button
            onClick={handleSignOut}
            className="f-btn f-btn-danger"
          >
            Sign Out
          </button>
        </div>
      </div>
    </div>
  );
}